import React, { useEffect, useState } from "react";

export default function Download(pokedex) {
  const data = pokedex["pokedex"];
  const [saveFile, setSaveFile] = useState("");
  useEffect(
    () => {
      const output = JSON.stringify(data);
      const blob = new Blob([output]);
      const fileDownloadUrl = URL.createObjectURL(blob);
      setSaveFile(fileDownloadUrl);
    },
    [data]
  );

  return (
    <a
      href={saveFile}
      className="ui left floated button"
      download="pokedex.json"
    >
      <i className="download icon" />Download Data
    </a>
  );
}
